import { FunctionComponent } from "react";
import { Col, Row } from "react-bootstrap";
import { Color, Path } from "../../../env";
import { TbSquareNumber1, TbSquareNumber2, TbSquareNumber3 } from "react-icons/tb";
import { Button, icon, variant } from "../../form/Button";
import { RouteComponentProps } from "react-router-dom";

export interface MemberRegisterConfirmationProps extends RouteComponentProps { }

export const MemberRegisterConfirmation: FunctionComponent<MemberRegisterConfirmationProps> = props => (
    <>
        <h1 style={{ marginBottom: "2rem" }}>Registration Successful</h1>
        <p>Great news! You are one step away from becoming a Stumbled member. You should have received an email shortly confirming that you are the owner of the email address.</p>

        <div style={{ marginTop: "2rem" }}>
            <Row style={{ marginBottom: "2rem" }}>
                <Col xs={2} style={{ textAlign: "center" }}>
                    <TbSquareNumber1 size={50} color={Color.DarkGrey} />
                </Col>
                <Col style={{ display: "flex", alignItems: "center" }}>
                    <span style={{ fontWeight: 600, verticalAlign: "middle", }}>Open the "Stumbled - Verification Link" email in your inbox</span>
                </Col>
            </Row>

            <Row style={{ marginBottom: "2rem" }}>
                <Col xs={2} style={{ textAlign: "center" }}>
                    <TbSquareNumber2 size={50} color={Color.DarkGrey} />
                </Col>
                <Col style={{ display: "flex", alignItems: "center" }}>
                    <span style={{ fontWeight: 600, verticalAlign: "middle", }}>Click on the verification link</span>
                </Col>
            </Row>

            <Row style={{ marginBottom: "2rem" }}>
                <Col xs={2} style={{ textAlign: "center" }}>
                    <TbSquareNumber3 size={50} color={Color.DarkGrey} />
                </Col>
                <Col style={{ display: "flex", alignItems: "center" }}>
                    <span style={{ fontWeight: 600, verticalAlign: "middle", }}>And finally, <a href={Path.Login} style={{ color: Color.Primary, textDecoration: "none", fontWeight: 800 }}>login</a> and you're all good to go!</span>
                </Col>
            </Row>

            <Button style={{ width: "100%" }} buttonvariant={variant.Primary} name="I've verified" onClick={() => props.history.push(`${Path.Login}?redirect=${Path.RegisterShop}`)} />
        </div>
    </>
);
